import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import styles from './NewsDetail.module.css';

const NewseventsDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isNews = location.pathname.includes('/news/');

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getImageUrl = (imageData) => {
    const baseUrl = 'http://10.178.85.17:5001/uploads';
    if (!imageData) return '/fallback-image.jpg';

    if (isNews) {
      return imageData.image
        ? `${baseUrl}/news/${imageData.image}`
        : imageData.images && imageData.images[0]
        ? `${baseUrl}/news/${imageData.images[0]}`
        : '/fallback-image.jpg';
    } else {
      return imageData.images && imageData.images[0]
        ? `${baseUrl}/events/${imageData.images[0]}`
        : '/fallback-image.jpg';
    }
  };

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        setLoading(true);
        const endpoint = isNews ? '/news' : '/events';
        const response = await axios.get(`http://10.178.85.17:5001${endpoint}/${id}`);
        setItem(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching details:', err);
        setError(`Failed to load ${isNews ? 'news' : 'event'} details`);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [id, isNews]);

  if (loading) return <div className={styles.loading}>Loading...</div>;
  if (error) return <div className={styles.error}>{error}</div>;
  if (!item) return <div className={styles.notFound}>{isNews ? 'News' : 'Event'} not found</div>;

  return (
    <div className={styles.container}>
      <article className={styles.article}>
        <img 
          src={getImageUrl(item)} 
          alt={item.title} 
          className={styles.mainImage}
          onError={(e) => {
            e.target.src = '/fallback-image.jpg';
          }}
        />
        <div className={styles.content}>
          <h1 className={styles.title}>{item.title}</h1>
          
          <div className={styles.metadata}>
            {isNews ? (
              <>
                {item.author && <span className={styles.author}>By {item.author}</span>}
                <span className={styles.date}>
                  Published on {formatDate(item.createdAt)}
                </span>
              </>
            ) : (
              <>
                <span className={styles.date}>
                  {formatDate(item.startDate)}
                  {item.endDate && ` - ${formatDate(item.endDate)}`}
                </span>
                {item.location && (
                  <span className={styles.location}>
                    Location: {item.location}
                  </span>
                )}
              </>
            )}
          </div>

          {item.description && (
            <div className={styles.description}>
              {item.description}
            </div>
          )}

          <div className={styles.body}>
            {item.content}
          </div>

          {!isNews && item.registrationLink && (
            <div className={styles.registration}>
              <a 
                href={item.registrationLink} 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.registerButton}
              >
                Register for this event
              </a>
            </div>
          )}
        </div>
      </article>
    </div>
  );
};

export default NewseventsDetail;
